module.exports = __webpack_public_path__ + "static/media/tbf-logo.281f014c.png";